import { Reducer } from '@reduxjs/toolkit'

import {
  ActionTypes,
  END_PUNCHCLOCK_TIME_SUCCESS,
  GET_PUNCHCLOCK_TIMES,
  GET_PUNCHCLOCK_TIMES_FAILURE,
  GET_PUNCHCLOCK_TIMES_SUCCESS,
  START_PUNCHCLOCK_TIME_SUCCESS,
} from './ActionTypes'
import IState from './IState'

const initialState: IState = {
  isLoading: false,
  error: false,
  times: undefined,
}

export const punchlcockReducer: Reducer<IState, ActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_PUNCHCLOCK_TIMES:
      return {
        ...state,
        isLoading: true,
      }
    case GET_PUNCHCLOCK_TIMES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        times: action.payload.times,
      }
    case GET_PUNCHCLOCK_TIMES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      }
    case START_PUNCHCLOCK_TIME_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        times: [...state.times, action.payload.time],
      }
    case END_PUNCHCLOCK_TIME_SUCCESS:
      const idx = state.times.findIndex(
        time => time.id === action.payload.time.id,
      )

      return {
        ...state,
        isLoading: false,
        error: false,
        times: [
          ...state.times.slice(0, idx),
          action.payload.time,
          ...state.times.slice(idx + 1),
        ],
      }
    default:
      return state
  }
}
